<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div class="post-search-page mb-4">
    <b-card v-if="post">
      <section class="d-flex justify-content-between">
        <router-link v-if="post.post_type === 'Digital'" :to="{ name: 'post-search-digital' }">
          &laquo; Post search
        </router-link>
        <router-link v-if="post.post_type === 'Physical'" :to="{ name: 'post-search-physical' }">
          &laquo; Post search
        </router-link>
        <router-link v-if="post.reply_image" :to="{ name: 'post-reply-search' }">
          &laquo; Post reply search
        </router-link>
      </section>
    </b-card>

    <div class="row" v-if="!loading">
      <section class="col-12" v-if="post">

        <section class="details-overview">
          <h3 class="font-weight-bolder">Details</h3>

          <b-card>
            <div class="row">
              <p cy="status" class="col-3"><b class="d-block">
                Status</b> {{ post.status === 'AwaitingConfirmation' ? 'Needs Approval' : post.status  }}
              </p>
              <p v-if="post.status === 'Rejected'" cy="rejection-reason" class="col-3"><b class="d-block">
                Rejection Reason</b> {{ post.rejection_reason || 'Not specified' }}
              </p>
              <p cy="delivery-status" class="col-3" v-if="post.post_type === 'Physical'"><b class="d-block">Delivery
                Status </b> {{ getDeliveryStatusFromPost(post) }} </p>
              <p cy="created" class="col-3"><b class="d-block">Created </b> {{ post.created_at | formatDateTime }} </p>
              <p cy="updated" class="col-3"><b class="d-block">Last Updated </b> {{ post.updated_at | formatDateTime }}
              </p>
              <p cy="location" class="col-3" v-if="post.prisoner_location && post.post_type === 'Physical'">
                <b class="d-block">{{ $options.filters.term('prisoner') | capEachWord }} Location </b>
                {{ post.prisoner_location }}
              </p>
              <p cy="reviewed_by" class="col-3">
                <b class="d-block">Reviewed By</b>
                {{getReviewedBy(post)}}
              </p>
              <p class="col-3 cursor-pointer" @click="copyPrisonerNumber">
                <b class="d-block">{{ $options.filters.term('prisoner') | capEachWord }} Number</b>
                {{ post.prisoner_number }}
              </p>

              <p v-if="post.contact" class="col-3">
                <b class="d-block">
                  {{ $options.filters.term('prisoner') | capEachWord }}'s Assigned Name
                </b>
                {{ post.contact.firstname }} {{ post.contact.lastname }}
              </p>

              <div v-if="prison.purple_post_foreign_language_requires_approval && foreignLanguages && foreignLanguages.length > 0" class="col-3">
                <b class="d-block">Foreign Languages Detected</b>
                <span v-for="(lang, index) in foreignLanguages" :key="index">
                  {{ getCountryNameFromCode(lang.language_code) }}<span v-if="index < foreignLanguages.length - 1">, </span>
                </span>
              </div>

              <div v-if="analysis && keywordCount" class="col-3">
                <b class="d-block">Keyword Alerts Found</b>
                <p>
                  {{ keywordCount }} Keyword{{ keywordCount > 1 ? 's' : '' }} found
                </p>
              </div>

              <p class="col-12 text-danger" v-if="prison.purple_post_gif_requires_approval && post.image_is_a_gif">
                <b class="d-block text-danger">GIF Uploaded</b>
                Your account settings require that all GIFs be manually approved.
              </p>
              <p class="col-12 text-danger" v-if="prison.purple_post_image_requires_approval && !post.is_system_image">
                <b class="d-block text-danger">Image Uploaded</b>
                Your account settings require that all images be manually approved.
              </p>
              <p class="col-12 text-danger" v-if="post.post_type === 'Digital' && post.firstPost">
                <b class="d-block text-danger">First Post</b>
                This post is the first between the visitor and {{ $options.filters.term('prisoner')}}
              </p>
              <p class="col-12 text-danger" v-if="digitalRestriction">
                <b class="d-block text-danger">Prisoner Ban</b>
                This {{$options.filters.term('prisoner')}} has a ban currently in place. For the following reason: {{digitalRestriction.reason || '-'}}
              </p>
            </div>

            <section class="row" v-if="mailMonitor">
              <p class="col-3"><b class="d-block">Mail Monitoring Active</b>Reason:
                {{ mailMonitor.reason || 'Not specified' }}</p>
            </section>
          </b-card>
        </section>

        <section v-if="!is_clinician">
          <h3 class="font-weight-bolder">Sender details</h3>

          <b-card>
            <b-spinner v-if="loadingVisitor" variant="primary" label="Loading visitor"></b-spinner>

            <section v-else>
              <sender-details
                @refresh="getPost()"
                v-if="visitor"
                :visitor="visitor"
                :show-ban-button="!print_queue_user"
              />
            </section>
          </b-card>
        </section>

        <section class="d-flex flex-wrap mb-3">
          <h3 class="full-width font-weight-bolder">Postcard</h3>
          <post-card class="mx-auto" :post="post"/>
        </section>

        <section>
          <h3 class="font-weight-bolder">Post Contents</h3>
          <b-card>
            <p>
              {{post.message}}
            </p>
          </b-card>
        </section>

        <section v-if="post.status !== 'Pending'">
          <h3 class="font-weight-bolder">Post Analysis</h3>
          <post-analysis :post="post"/>
        </section>

        <section v-if="post.status === 'AwaitingConfirmation' && !print_queue_user">
          <h3 class="font-weight-bolder">Judge Post</h3>

          <judge-post
            v-if="post.post_type === 'Digital'"
            @refresh="$router.push({name: 'post-search-digital'})"
            :post="post"/>
          <judge-post
            v-else-if="post.post_type === 'Physical'"
            @refresh="$router.push({name: 'post-search-physical'})"
            :post="post"/>
        </section>

        <section v-if="post.print_on_site && !is_clinician && post.post_type !== 'Digital'">
          <h3 class="font-weight-bolder">Print on site</h3>
          <print-on-site :post="post"/>
        </section>

        <section v-if="post.reply_image_url">
          <h3 class="font-weight-bolder">Reply</h3>
          <post-reply :post="post"></post-reply>
        </section>

        <section v-if="post.post_type === 'Digital'">
          <h3 class="font-weight-bolder">Digital Replies</h3>

          <post-digital-reply :post="post"></post-digital-reply>
        </section>

      </section>
      <section v-else>
        <h4>No post found</h4>
      </section>
    </div>

    <section v-else>
      <b-spinner variant="primary" label="Loading post"></b-spinner>
    </section>
  </div>
</template>
<!-- eslint-enable -->

<script>
import Vue from 'vue';
import { mapState } from 'vuex'
import MailMonitorService from '@/services/MailMonitorService'
import PostReply from '@/views/postView/sections/PostReply.vue'
import PostDigitalReply from '@/views/postView/sections/postDigitalReply/PostDigitalReply.vue'
import StringUtils from '@/util/StringUtils';
import PostCard from './sections/PostCard.vue'
import SenderDetails from './sections/SenderDetails.vue'
import PrintOnSite from './sections/PrintOnSite.vue'
import PostAnalysis from './sections/PostAnalysis.vue'
import PostService from '../../services/PostService'
import JudgePost from './sections/JudgePost.vue'
import DigitalMailRestrictionsService from '../../services/DigitalMailRestrictionsService';
import Countries from '../../components/country/countryCodes.json';
import PrisonService from '@/services/PrisonService';

export default {
  name: 'PostView',
  components: {
    PostCard,
    SenderDetails,
    PrintOnSite,
    PostAnalysis,
    JudgePost,
    PostReply,
    PostDigitalReply,
  },
  props: {
    id: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      loading: true,
      loadingVisitor: true,
      loadingPrison: true,
      loadingMonitor: true,
      post: {},
      mailMonitor: null,
      digitalRestriction: null,
      prison: null,
    }
  },
  computed: {
    ...mapState({
      is_primary_user: state => !state.auth.user.is_clinician && !state.auth.user.is_print_queue_user,
      is_clinician: state => state.auth.user.is_clinician,
      print_queue_user: state => state.auth.user.is_print_queue_user,
      visitor: state => state.postCard.visitor,
      foreignLanguages: state => state.postCard.foreignLanguages,
      analysis: state => state.postCard.analysis,
    }),
    keywordCount() {
      return this.analysis && Array.isArray(this.analysis.keyword_alerts)
        ? this.analysis.keyword_alerts.length
        : 0;
    },
  },
  mounted() {
    this.getPost()
  },
  methods: {
    async getPost() {
      this.loading = true
      try {
        const { data } = await PrisonService.getPrison()
        this.prison = data
      } catch (err) {
        console.log('could not get posts prison', err)
        this.$toast.error('Could not get post, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        })
        return
      }

      PostService.getPost(this.id)
        .then(res => {
          this.post = res.data
          this.$store.commit('postCard/SET_ACTIVE_MESSAGE', this.post.message)
          this.getVisitorDetails()
          this.getMailMonitoringForPrisoner()

          if (this.post.post_type === 'Digital') {
            this.checkFirstPost();
            this.checkForDigitalRestriction(this.post.prisoner_number)
          }
        })
        .catch(err => {
          console.log('could not get post', err)
          this.$toast.error('Could not get post, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getVisitorDetails() {
      this.loadingVisitor = true;
      await this.$store.dispatch('postCard/getVisitor', this.post.user_id)
      this.loadingVisitor = false;
    },
    getMailMonitoringForPrisoner() {
      this.loadingMonitor = true
      MailMonitorService.getMonitor(this.post.prisoner_number)
        .then(res => {
          this.mailMonitor = res.data
        })
        .catch(err => {
          console.log('could not get mail monitor', err)
          this.$toast.error('Could not get mail monitor, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          })
        })
        .finally(() => {
          this.loadingMonitor = false
        })
    },
    getDeliveryStatusFromPost(post) {
      return PostService.getDeliveryStatusTextFromPostOptions(post.sent_for_printing, post.dispatched, post.delivered)
    },
    checkFirstPost() {
      PostService.checkFirstPost(this.post._id).then(res => {
        Vue.set(this.post, 'firstPost', res.data);
      }).catch(() => {
        this.$toast.error('Could not detect if psot was first post, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        })
      })
    },
    checkForDigitalRestriction(prisonerNumber) {
      // Only primary users have access
      if (!this.is_primary_user) {
        return
      }
      DigitalMailRestrictionsService.getForPrisoner(prisonerNumber).then(res => {
        this.digitalRestriction = res.data
      }).catch(() => {})
    },
    getReviewedBy(post) {
      if (post.status === 'Requested' || post.status === 'AwaitingConfirmation') {
        return '-'
      }
      if (post.reviewer && post.reviewer.name) {
        return StringUtils.toTitleCase(post.reviewer.name);
      }
      return 'System';
    },
    copyPrisonerNumber() {
      navigator.clipboard.writeText(this.post.prisoner_number);
      this.$toast.success('Copied!', {
        toastClassName: ['toast-std', 'success-toast'],
      });
    },
    getCountryNameFromCode(code) {
      const country = Countries.find(item => item.code.toLowerCase() === code.toLowerCase());
      return country ? country.name : code;
    },
  },
}
</script>
